import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../redux';
import { selectIsAuthenticated, selectIsAuthInitialized } from '../features/AuthSlice/AuthSelectors';
import { loginVerified, previewLoginVerified } from '../features/AuthSlice/AuthSlice';
import { getMembershipLoginUrl } from '../constants/urls';
import { getPreviewState } from '../utils/getPreviewState';
const previewState = getPreviewState();
export const useLoginVerify = () => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isAuthInitialized = useAppSelector(selectIsAuthInitialized);
  const membershipLoginUrl = useMemo(() => getMembershipLoginUrl(window.location.href), []);
  useEffect(() => {
    if (previewState.isPreview && previewState.previewJwt) {
      void dispatch(previewLoginVerified(previewState.previewJwt));
    } else if (!previewState.isPreview) {
      void dispatch(loginVerified());
    }
  }, [dispatch]);
  useEffect(() => {
    if (previewState.isPreview) {
      return;
    }
    // redirect to Membership Platform login if auth check has settled and user is not authenticated
    if (isAuthInitialized && !isAuthenticated) {
      window.location.replace(membershipLoginUrl);
    }
  }, [isAuthenticated, isAuthInitialized, membershipLoginUrl]);
  return {
    loading: !isAuthInitialized,
    isLoggedIn: isAuthenticated
  };
};